
import CustomLink from '../CustomLink/CustomLink';
import logo from '../img/login.png'
import { useSendPasswordResetEmail, useSignInWithEmailAndPassword, useSignInWithGoogle } from 'react-firebase-hooks/auth';
import auth from '../firebase.init';
import icon from '../img/google.png';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Login = () => {
    const [emails, setEmails] = useState('');
    const [sendPasswordResetEmail, sending] = useSendPasswordResetEmail(
        auth
    );
    const [signInWithGoogle, googleUser] = useSignInWithGoogle(auth);
    const navigate = useNavigate();
    const [
        signInWithEmailAndPassword,
        user,
        loading,
        error,
    ] = useSignInWithEmailAndPassword(auth);

    if (googleUser) {
        navigate('/checkout');
    }

    if (user) {
        navigate('/checkout');
    }

    const handleSignIn = (event) => {

        event.preventDefault();
        const email = event.target.email.value;
        const password = event.target.password.value;
        signInWithEmailAndPassword(email, password);

    }




    return (
        <div>
            <div className="row justify-content-center">
                <div className="col-md-4 p-5">
                    <div class="shadow p-3 mb-5 bg-body rounded">


                        <img style={{ height: '80px', width: '80px' }} src={logo} alt="" />
                        <h3 class="text-center mb-3">Log In</h3>
                        <form onSubmit={handleSignIn}>
                            <div class="form-group">
                                <input type="text" name="email" onChange={(e) => setEmails(e.target.value)} class="form-control rounded-left" placeholder="Username" required />
                            </div>
                            <div class="form-group d-flex mt-3">
                                <input type="password" name="password" class="form-control rounded-left" placeholder="Password" required />
                            </div>
                            <div class="form-group d-md-flex mt-3 ">
                                <div class="w-50">
                                    <label class="checkbox-wrap checkbox-primary">
                                        You are not Registred?
                                    </label>
                                </div>
                                <div class="w-50 text-md-right">
                                    <CustomLink class='bg-white text-primary' to={'/register'}>
                                        Create Account
                                    </CustomLink >

                                    <button className='bg-transparent border-0 text-primary' onClick={async () => {
                                        await sendPasswordResetEmail(emails);
                                        toast("Wow so sent email!");
                                    }}> Forgot Password</button>
                                    <ToastContainer />

                                </div>
                            </div>
                            <p className='text-danger'>{error?.message}</p>
                            {
                                loading && <p className='text-success'>Loading...</p>
                            }

                            <div class="form-group mt-3 mb-3">
                                <button type="submit" name="submit" class="form-control btn btn-primary rounded submit px-3">Login</button>
                            </div>


                        </form>

                        <button onClick={() => signInWithGoogle()} className='btn btn-dark'>   <img style={{ width: '30px' }} className='icon' src={icon} alt="" />Google Login</button>


                    </div>
                </div>
            </div>

        </div >
    );
};

export default Login;